import React from 'react'
import { Row, Col, Button, Divider, InputNumber, Form } from 'antd';

export default function CalculateVolumeToolTip({ t, form, calculateMediaVolume, updateMediaVolumeVal, visible, close }) {

  if(!visible) {
    return "";
  }
  
  const { getFieldDecorator } = form;
  
  return (
    <div className="popup-container">
      <Row gutter={[8, 8]} className="w-300">
        <Col span={9}>
          <Form.Item label={t('form.foodWeight')}>
            {getFieldDecorator('foodWeight', {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    let data = parseFloat(value);
                    if (!data || data < 0) {
                      callback(t('form.foodWeightInvalid'));
                      return false;
                    }
                    callback();
                  }
                }
              ],
            })(<InputNumber type="number" step={0.1} min={0.1} suffix="gr" size="small" />)
            }
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item label={t('form.dilutionFactor')}>
            {getFieldDecorator('dilutionFactor', {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    let data = parseInt(value);
                    if (!data || data < 2) {
                      callback(t('form.dilutionFactorInvalid'));
                      return false;
                    }
                    callback();
                  }
                }
              ],
            })(<InputNumber precision={0} type="number" min={2} size="small" />)
            }
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item className="pt-40">
            <Button type="primary" size="small" className="primary-dark" onClick={() => calculateMediaVolume()}>Calculate</Button>
          </Form.Item>
        </Col>
        <Col span={2} align="right">
          <Button type="link" icon="close" onClick={() => close()}>
          </Button>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[8, 8]} type="flex" align="bottom" className="w-300">
        <Col span={15}>
          <Form.Item label={t('form.calculatedVal')}>
            {getFieldDecorator('calculatedVal', {
             rules: [
              {
                  required: true,
                  validator: (rule, value, callback) => {
                      let data = parseInt(value);
                      if (!data) {
                          callback(t('form.inputerrormsg', { field: "Media Volume" }));
                      } else if (data < 90 || data > 9999) {
                          callback(t('form.calcVolumeMinAndMax'));
                          return false;
                      }

                      callback();
                  }
              }
          ],
            })(<InputNumber  type="number" disabled={true} size="small"  />)
            }
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item>
            <Button size="small" type="primary" className="primary-dark" onClick={() => updateMediaVolumeVal()}>Apply</Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}
